import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/get_account_order',
  component: Layout,
  redirect: '/get_account_order/index',
  name: 'getAccountOrder',
  meta: {
    title: '获取账号订单',
    i18n: 'route.tabbar',
    icon: 'game-icons:3d-glasses',
  },
  children: [
    {
      path: 'index',
      name: 'getAccountOrderIndex',
      component: () => import('@/views/get_account_order/index.vue'),
      meta: {
        title: '获取账号订单',
        i18n: 'route.tabbar',
        menu: false,
        breadcrumb: false,
        activeMenu: '/get_account_order',
      },
    },
  ],
}

export default routes
